import React, { Component } from 'react';
import Link from 'react-router-dom/Link';

export default class Footer extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    const currentYear = new Date().getFullYear();

    return (
      <footer className="footer">
        <nav className="footer__nav-wrapper">
          <ul className="footer__link-container">
            <li className="footer__link">
              <a href="https://spotlight.fastcompany.com/">Advertise</a>
            </li>
            <li className="footer__link">
              <a href="https://www.fastcompany.com/privacy-policy">
                Privacy&nbsp;Policy
              </a>
            </li>
            <li className="footer__link">
              <a href="https://www.fastcompany.com/terms-and-conditions">
                Terms
              </a>
            </li>
            <li className="footer__link">
              <a href="https://www.fastcompany.com/contact-us">Contact</a>
            </li>
            <li className="footer__link">
              <a href="https://www.fastcompany.com/about-us">About Us</a>
            </li>
            <li className="footer__link">
              <Link to="/sitemap">Site Map</Link>
            </li>
            {/* eslint-disable max-len */}
            <li className="footer__link">
              Fast Company & Inc © {currentYear} Mansueto Ventures, LLC
            </li>
            <li className="footer__link">
              <a href="https://www.aboutads.info/" rel="nofollow">
                <img
                  className="footer__daa-logo"
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAANCAAAAAC4QtCeAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAAJ0Uk5TAAB2k804AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAAAEgAAABIAEbJaz4AAACASURBVAjXYyir3PaDAQby09KL9/2FcjIWf1mbVX0Mwklfw8DwbF5awzkwZzXDjco/j/vTuq+COe93APXcLE5bCeKczvzOwPCoPG0xiHMq6/f9SWkdF4HK1jKcyepJazgFNnrBpwtpVUchRuempR17+htqaU/55l9w5xzf+RHOBgC94zlXyQTR6wAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxMy0wMy0wOFQxOToxMDo0NC0wNTowMNnS5vEAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTMtMDMtMDhUMTk6MTA6NDQtMDU6MDCoj15NAAAAAElFTkSuQmCC"
                  alt="Digital Advertising Alliance (DAA) Self-Regulatory Program"
                  target="_new"
                />
              </a>
            </li>
            {/* eslint-enable max-len */}
          </ul>
        </nav>
      </footer>
    );
  }
}
